import BatchTaxEntriesAmountCellRenderer from '../cellRenderers/batchTaxEntriesAmountCellRenderer';
import YesNoFlagRenderer from '../cellRenderers/yesNoFlagColumnRenderer.component';

import {
  accountColumnDefinition,
  activityColumnDefinition,
  netAmountColumnDefinition,
  grossAmountColumnDefinition,
  bookTypeColumnDefinition,
  companyCodeColumnDefinition,
  countryCodeColumnDefinition,
  countryTaxTypeColumnDefinition,
  countryTaxTypeDescriptionColumnDefinition,
  entryDateColumnDefinition,
  entryTypeColumnDefinition,
  methodColumnDefinition,
  postedFlagColumnDefinition,
  preparerColumnDefinition,
  reviewerColumnDefinition,
  taxCurrencyColumnDefinition,
  taxYearColumnDefinition,
  topsideFlagColumnDefinition,
  fbosFlagColumnDefinition,
  payableTagColumnDefinition,
} from '../columnDefinitions';

export const baseTaxEntriesColumnDefs = [
  companyCodeColumnDefinition,
  taxYearColumnDefinition,
  countryTaxTypeColumnDefinition,
  entryTypeColumnDefinition,
  { ...activityColumnDefinition, field: 'taxEntryActivityDescription' },
  { ...bookTypeColumnDefinition, field: 'bookTypeDescription' },
  { ...accountColumnDefinition, field: 'adjustmentDescription' },
  taxCurrencyColumnDefinition,
];

export const batchTaxEntriesColumnDefs = [
  companyCodeColumnDefinition,
  taxYearColumnDefinition,
  countryTaxTypeColumnDefinition,
  { ...countryTaxTypeDescriptionColumnDefinition, hide: true },
  { ...entryTypeColumnDefinition, field: 'entryType' },
  { ...activityColumnDefinition, field: 'entryActivity' },
  bookTypeColumnDefinition,
  payableTagColumnDefinition,
  accountColumnDefinition,
  { ...netAmountColumnDefinition, cellRenderer: BatchTaxEntriesAmountCellRenderer },
  { ...grossAmountColumnDefinition, cellRenderer: BatchTaxEntriesAmountCellRenderer },
  { ...fbosFlagColumnDefinition, cellRenderer: YesNoFlagRenderer },
  { ...topsideFlagColumnDefinition, field: 'topsideFlag', cellRenderer: YesNoFlagRenderer },
];

export const taxEntriesColumnDefs = [
  ...batchTaxEntriesColumnDefs,
  entryDateColumnDefinition,
  preparerColumnDefinition,
  methodColumnDefinition,
  topsideFlagColumnDefinition,
];

export const approveTaxEntriesColumnDefs = [
  companyCodeColumnDefinition,
  taxYearColumnDefinition,
  countryTaxTypeDescriptionColumnDefinition,
  entryTypeColumnDefinition,
  { ...activityColumnDefinition, field: 'taxEntryActivityDescription' },
  { ...bookTypeColumnDefinition, field: 'bookTypeDescription' },
  payableTagColumnDefinition,
  { ...accountColumnDefinition, field: 'adjustmentDescription' },
  taxCurrencyColumnDefinition,
  netAmountColumnDefinition,
  grossAmountColumnDefinition,
  entryDateColumnDefinition,
  preparerColumnDefinition,
  methodColumnDefinition,
  topsideFlagColumnDefinition,
  { ...fbosFlagColumnDefinition, cellRenderer: YesNoFlagRenderer },
];

export const viewTaxEntriesColumnDefs = [
  postedFlagColumnDefinition,
  topsideFlagColumnDefinition,
  companyCodeColumnDefinition,
  taxYearColumnDefinition,
  countryCodeColumnDefinition,
  countryTaxTypeColumnDefinition,
  entryTypeColumnDefinition,
  { ...activityColumnDefinition, field: 'taxEntryActivityDescription' },
  { ...bookTypeColumnDefinition, field: 'bookTypeDescription' },
  payableTagColumnDefinition,
  { ...accountColumnDefinition, field: 'adjustmentDescription' },
  taxCurrencyColumnDefinition,
  netAmountColumnDefinition,
  grossAmountColumnDefinition,
  entryDateColumnDefinition,
  preparerColumnDefinition,
  reviewerColumnDefinition,
  methodColumnDefinition,
];
